module.exports = __webpack_public_path__ + "img/punt_left.4f511f41.jpg";